<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['loadMore']);

const { t } = useI18n();
</script>

<template>
  <div
    class="mt-3 flex justify-center border-t border-auth-border py-4 dark:border-auth-border-dark"
  >
    <Button
      :label="t('CONTACTS_LAYOUT.LOAD_MORE')"
      :is-loading="isLoading"
      variant="faded"
      color="slate"
      size="sm"
      class="!rounded-xl !border-auth-border !bg-auth-soft !text-auth-text hover:!bg-auth-border dark:!border-auth-border-dark dark:!bg-auth-soft-dark dark:!text-auth-text-dark dark:hover:!bg-auth-border-dark"
      @click="emit('loadMore')"
    />
  </div>
</template>
